import {OriginalStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/OriginalStaticLandingPageVo.interface';
import {
  StaticLandingOriginalParamInput,
  StaticLandingOriginalSectionParam,
} from '../generated/types';
import {createSortOption} from './SortOption';

export function createStaticLandingOriginalSectionParam(
  vo: OriginalStaticLandingPageVo,
  input: StaticLandingOriginalParamInput
): StaticLandingOriginalSectionParam {
  return {
    categoryUid: input.categoryUid,
    subcategory: vo.selected_subcat_opt
      ? createSortOption({
          sortOptVo: vo.selected_subcat_opt,
        })
      : undefined,
    sortType: vo.selected_sort_opt
      ? createSortOption({
          sortOptVo: vo.selected_sort_opt,
        })
      : undefined,
    isComplete: input.isComplete,
    page: input.page,
  };
}
